<template>
  <div class="doc-admin-page">
    <header class="doc-header">
      <div>
        <p class="eyebrow">OPEN API DOCUMENT</p>
        <h1>第三方接口文档管理</h1>
        <p>维护用户首页展示的第三方接入文档，保存后用户端会读取最新内容。</p>
      </div>
      <button class="primary-btn" :disabled="saving" @click="saveDoc">{{ saving ? '保存中...' : '保存文档' }}</button>
    </header>

    <section v-loading="loading" class="doc-grid">
      <div class="editor-card">
        <el-form label-position="top">
          <el-form-item label="文档标题">
            <el-input v-model.trim="doc.title"></el-input>
          </el-form-item>
          <el-form-item label="版本号">
            <el-input v-model.trim="doc.version"></el-input>
          </el-form-item>
          <el-form-item label="摘要">
            <el-input v-model.trim="doc.summary" type="textarea" :rows="3"></el-input>
          </el-form-item>
          <el-form-item label="正文内容（支持 Markdown 风格文本）">
            <el-input v-model="doc.content" type="textarea" :rows="22"></el-input>
          </el-form-item>
          <el-form-item label="展示状态">
            <el-radio-group v-model="doc.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="preview-card">
        <span class="preview-badge">{{ doc.version || 'v1.0' }}</span>
        <h2>{{ doc.title || '未命名文档' }}</h2>
        <p>{{ doc.summary || '暂无摘要' }}</p>
        <pre>{{ doc.content || '暂无正文内容' }}</pre>
      </div>
    </section>
  </div>
</template>

<script>
import { getAdminOpenApiDoc, saveAdminOpenApiDoc } from '../api/market'

export default {
  name: 'AdminOpenApiDoc',
  data() {
    return {
      loading: false,
      saving: false,
      doc: {
        id: 1,
        title: '',
        version: '',
        summary: '',
        content: '',
        status: 1
      }
    }
  },
  created() {
    this.fetchDoc()
  },
  methods: {
    async fetchDoc() {
      this.loading = true
      try {
        const response = await getAdminOpenApiDoc()
        if (response.data.code === 200 && response.data.data) {
          this.doc = {
            ...this.doc,
            ...response.data.data
          }
        }
      } catch (error) {
        this.$message.error('文档加载失败')
      } finally {
        this.loading = false
      }
    },
    async saveDoc() {
      this.saving = true
      try {
        const response = await saveAdminOpenApiDoc(this.doc)
        if (response.data.code !== 200) {
          this.$message.error(response.data.msg || '文档保存失败')
          return
        }
        this.doc = {
          ...this.doc,
          ...response.data.data
        }
        this.$message.success('第三方接口文档已保存')
      } catch (error) {
        this.$message.error('文档保存请求失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.doc-admin-page {
  min-height: 100vh;
  padding: 28px;
  color: #f6fbff;
}

.doc-header,
.editor-card,
.preview-card {
  border: 1px solid rgba(143, 241, 199, 0.14);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.06);
}

.doc-header {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 24px;
  margin-bottom: 18px;
}

.eyebrow {
  margin: 0 0 8px;
  color: #8ff1c7;
  font-size: 12px;
  letter-spacing: 0.18em;
}

.doc-header h1 {
  margin: 0;
  font-size: 30px;
}

.doc-header p {
  margin: 8px 0 0;
  color: rgba(246, 251, 255, 0.66);
}

.doc-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(360px, 0.82fr);
  gap: 18px;
}

.editor-card,
.preview-card {
  padding: 20px;
}

.editor-card :deep(.el-form-item__label) {
  color: rgba(246, 251, 255, 0.82);
}

.primary-btn {
  min-width: 120px;
  height: 40px;
  border: none;
  border-radius: 999px;
  color: #03101d;
  font-weight: 800;
  cursor: pointer;
  background: linear-gradient(135deg, #8ff1c7, #ffd08a);
}

.preview-badge {
  display: inline-flex;
  margin-bottom: 12px;
  padding: 6px 10px;
  border-radius: 999px;
  color: #03101d;
  background: #8ff1c7;
  font-weight: 900;
}

.preview-card h2 {
  margin: 0;
}

.preview-card p {
  color: rgba(246, 251, 255, 0.68);
  line-height: 1.7;
}

.preview-card pre {
  min-height: 430px;
  margin: 16px 0 0;
  padding: 16px;
  overflow: auto;
  white-space: pre-wrap;
  color: rgba(246, 251, 255, 0.86);
  line-height: 1.75;
  border-radius: 16px;
  background: rgba(2, 8, 17, 0.62);
}

@media (max-width: 980px) {
  .doc-grid {
    grid-template-columns: 1fr;
  }
}
</style>
